import React from 'react';
import PropTypes from 'prop-types';

import { VpIcon } from '../VpIcon';

import { StyledSocialButton } from './styles';

const facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=';

export const VpShareToFacebook = ({ link = '' }) => {
  const facebookShareUrl = `${facebookLink}${encodeURIComponent(link)}`;

  return (
    <a href={facebookShareUrl} target="_blank" rel="noopener noreferrer">
      <StyledSocialButton variant="contained">
        <VpIcon icon="Facebook" />
      </StyledSocialButton>
    </a>
  );
};

VpShareToFacebook.propTypes = {
  link: PropTypes.string
};

export default VpShareToFacebook;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpSocialMediaShareButtons/VpShareToFacebook.jsx